import * as React from 'react'
import Block from './Block'

export default function BlockGroup({ style, blocks }) {
	return (
		<div className={style}>
			{blocks?.map((block) => (
				<Block {...block} key={block?._key} />
			))}
		</div>
	)
}
